class BasicStrategy {
  async start(initalData) {
    await this.$vm.startFlow(initalData)
  }

  async finally() {
    // 更新数量
    this.$vm.updateAmount()
    // 根据扫到的条码生成厂家原始条码
    this.$vm.createOriginBarCode()
    // >> 判断是否扫到生产日期或效期，确定是否反算
    await this.$vm.calcOfValue()
    // 自动提交
    if (this.$vm.enabledAutoSubmit) {
      await this.$vm.onScanConfirm()
    }

    // 正确识别后清除扫码输入框
    console.log('是否正确识码: ', this.$vm.scanResult.success)
    if (this.$vm.scanResult.success) {
      console.log('正确识别后清除扫码输入框')
      this.$vm.clearInput()
    }
  }
}

export default BasicStrategy
